import Router from '../../routes/Router'
import routes from '../../routes/definitions'

export function ClassifiedListPaginationTransformer({
  routeId,
  currentPage,
  nbPages,
}: {
  routeId: number | string
  currentPage: number
  nbPages: number
}) {
  return {
    items: Array.from(Array(nbPages).keys()).map((_, idx) => {
      const value = idx + 1
      return {
        text: String(value),
        current: value === currentPage,
        href: Router.getRouteUrl(routes.classifiedsEmitterPaginated, {
          id: routeId,
          page: value,
        }),
      }
    }),
  }
}
